import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, Grid, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import { LeaderboardConfigFragment, useGetLeaderboardConfigScoresQuery } from 'api';
import { Loaders } from 'components';
import { useNotify } from 'hooks';

import EditablePointTable from './EditablePointTable';

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: 0,
    paddingBottom: theme.spacing(2),
  },
  text: {
    borderBottom: 0,
  },
}));

interface IProps {
  open: boolean;
  onClose: () => void;
  config: LeaderboardConfigFragment;
}

const EditablePointDialog: FC<IProps> = ({ config, open, onClose }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const notify = useNotify();
  const { id, title } = config;

  const { data, isLoading } = useGetLeaderboardConfigScoresQuery(
    { id },
    {
      onError: notify.queryError,
    }
  );

  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <DialogTitle disableTypography className={classes.title}>
        <Grid container direction="column" wrap="nowrap" spacing={1}>
          <Grid item>
            <Typography variant="subtitle2">{title}</Typography>
          </Grid>
          <Grid item>
            <Typography>{t('leaderboard:actionsEdit')}</Typography>
          </Grid>
        </Grid>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {isLoading ? (
        <Loaders.Standard />
      ) : (
        <EditablePointTable id={id} scores={data.getLeaderboardConfigScores} />
      )}
    </Dialog>
  );
};

export default EditablePointDialog;
